import React from "react";
import PartyRepresentativeCard from "./PartyRepresentativeCard"; // adjust path if needed

const TestPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 p-6 flex justify-center items-center">
      <PartyRepresentativeCard
        name="Asha Kumari"
        image="/image/asha-kumari.jpg"
        position="MLA"
        party="Indian National Congress"
        state="Himachal Pradesh"
        constituency="Dalhousie"
      />
    </div>
  );
};

export default TestPage;
